// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__Aj43J","background":"Modal_background__Sj-I6","inner":"Modal_inner__s1R1z"};